import { HStack, Stack, Text } from '@chakra-ui/react';

import DashboardService from '@/client/services/api/DashboardService';
import LearnerDashboardCertificatePreviewCard from './LearnerDashboardCertificatePreviewCard';
import LearnerDashboardNoDataPlaceholder from '@/client/components/learners/dashboard/components/LearnerDashboardNoDataPlaceholder';
import { useAuthStore } from '@/client/services/state/authStore';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export default function LearnerDashboardCertificates() {
  const { t } = useTranslation();
  const { authConfig } = useAuthStore();
  const { user } = authConfig;
  const { _id: userId } = user;

  const { data, isLoading, isError } = useQuery({
    queryKey: ['query-user-certificates', userId],
    queryFn: () => DashboardService.getUserCertificates(userId),
  });

  if (isLoading) return <div>Loading...</div>;

  if (isError) return <div>Error</div>;

  return (
    <Stack spacing={4}>
      <Text fontSize="18px" fontWeight={600}>
        {t('learners.dashboard.achievements.certificates')}
      </Text>

      {data.length === 0 && (
        <LearnerDashboardNoDataPlaceholder
          imagePath="/public/images/Knowledge-Base-2--Streamline-Brooklyn.svg"
          title={t('learners.dashboard.achievements.certificates.noneFound')}
          helpText=""
        />
      )}

      {data.length > 0 && (
        <HStack
          flexWrap="wrap"
          gap={8}
          spacing={8}
          justifyContent="flex-start"
          alignItems="flex-start"
          width="full"
        >
          {data.map((certificate) => (
            <LearnerDashboardCertificatePreviewCard
              key={`${certificate.title}-${certificate.completedDate.toISOString()}`}
              certificate={certificate}
            />
          ))}
        </HStack>
      )}
    </Stack>
  );
}
